import { APIRuntimeBuilder } from '@cian/mf-registry/browser';
import { ESearchType } from 'browser/utils';
import { TReduxStore } from 'shared/types/redux';
import { handleClickSearchSuggestion } from './handleClickSearchSuggestion';
import { handleSetJsonQuery } from './handleSetJsonQuery';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v1/set-filter-json-query',
      handler: async (data: { jsonQuery: object }) => {
        return handleSetJsonQuery(store, data);
      },
    },
    {
      path: '/v1/click-search-suggestion',
      handler: async (data: { type: ESearchType }) => {
        return handleClickSearchSuggestion(store, data);
      },
    },
  ];
}
